import styled from "styled-components";

export const Wrapper = styled.div`

    /* Add to your global CSS or component CSS module */
    .sales-rank-modal .apexcharts-svg {
        transform: scale(1) !important;
        transform-origin: top left !important;
    }

    .sales-rank-modal .apexcharts-tooltip {
        position: fixed !important;
        transform: translate3d(0, 0, 0) !important;
        will-change: transform !important;
        pointer-events: none !important;
        z-index: 9999 !important;
    }

    /* Force hardware acceleration */
    .sales-rank-modal .apexcharts-canvas {
        transform: translateZ(0);
        backface-visibility: hidden;
        perspective: 1000px;
    }

    /* Fix for zoom */
    @media screen and (min-resolution: 0.8dppx) {
        .sales-rank-modal .apexcharts-tooltip {
            transform: translate(0, 0) !important;
        }
    }
`